

export class SaveDeliveryPointPayload {

    constructor() {
        this.StaggingId = null;
        this.DeliveryLatitude = null;
        this.DeliveryLongitude = null;
        this.DeliveryPointName = "";
        this.CustomerId = "";
        this.PinType = "2";
        this.AllowsHeavyTruck = false;
        this.AgentId = null;
        this.TenantId = null;
    }

    StaggingId: any;
    DeliveryLatitude: any;
    DeliveryLongitude: any;
    DeliveryPointName: any;
    CustomerId: any;
    PinType: any;
    AllowsHeavyTruck: any;
    AgentId: any;
    TenantId: any;
}